import { TenantGroupBadge } from '../../../components/TenantGroupBadge/TenantGroupBadge'
import { formatDate } from '../../../helpers/formatDate'
import { InventorySystemTypes, BuildStatus } from '../../../types'
import type { InventorySystemProfileDTO, EditRowDef } from '../../../types'

const inventorySystemTypeOptions = Object.values(InventorySystemTypes).map((v) => ({
  label: v,
  value: v,
}))

const buildStatusOptions = Object.values(BuildStatus).map((v) => ({
  label: v,
  value: v,
}))

export function buildInventorySystemProfileEditRows(profile: InventorySystemProfileDTO): EditRowDef[] {
  return [
    { mode: 'readonly', label: 'ID', value: <span className="font-monospace small">{profile.id}</span> },
    { mode: 'readonly', label: 'Code', value: <span className="fw-medium">{profile.code}</span> },
    {
      mode: 'editable',
      field: { name: 'name', label: 'Name', type: 'text', required: true },
      initialValue: profile.name,
    },
    {
      mode: 'editable',
      field: {
        name: 'inventorySystemType',
        label: 'Type',
        type: 'select',
        required: true,
        options: inventorySystemTypeOptions,
      },
      initialValue: profile.inventorySystemType,
    },
    {
      mode: 'editable',
      field: { name: 'buildSchedule', label: 'Build Schedule', type: 'cron', required: true },
      initialValue: profile.buildSchedule,
    },
    {
      mode: 'editable',
      field: {
        name: 'buildStatus',
        label: 'Build Status',
        type: 'select',
        required: true,
        options: buildStatusOptions,
      },
      initialValue: profile.buildStatus,
    },
    {
      mode: 'editable',
      field: { name: 'availabilityBuildEnabled', label: 'Availability Build', type: 'checkbox' },
      initialValue: profile.availabilityBuildEnabled,
    },
    { mode: 'readonly', label: 'Tenant Group', value: <TenantGroupBadge tenantGroupId={profile.tenantGroupId} /> },
    { mode: 'readonly', label: 'Created', value: formatDate(profile.createdAt) },
    { mode: 'readonly', label: 'Updated', value: formatDate(profile.updatedAt) },
  ]
}
